module.exports = __webpack_public_path__ + "static/img/head-2-zh.f0076e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/head-2-zh.png
// module id = ZTjn
// module chunks = 1